module.exports = __webpack_public_path__ + "img/ic-dinnerscard.ad0daaac.svg";